var _path, _g, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2058_7071",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.950195 0.291687H30.8121V30H0.950195V0.291687Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2058_7071)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03809 2.76748C5.95053 2.76748 3.43884 5.26627 3.43884 8.33768V21.9542C3.43884 25.0258 5.95053 27.5244 9.03809 27.5244H22.7244C25.8117 27.5244 28.3236 25.0258 28.3236 21.9542V8.33768C28.3236 5.26627 25.8114 2.76748 22.7244 2.76748H9.03809ZM22.7244 30H9.0381C4.57847 30 0.950195 26.3908 0.950195 21.9539V8.33768C0.950195 3.90068 4.57847 0.291626 9.0381 0.291626H22.7244C27.1844 0.291626 30.8121 3.90068 30.8121 8.33768V21.9542C30.8121 26.3908 27.1844 30 22.7244 30Z",
    fill: "#FFDD00"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8813 10.1945C13.137 10.1945 10.9046 12.4157 10.9046 15.1458C10.9046 17.8764 13.137 20.0971 15.8813 20.0971C18.6252 20.0971 20.8581 17.8764 20.8581 15.1458C20.8581 12.4157 18.6262 10.1945 15.8813 10.1945ZM15.8813 22.5728C11.7646 22.5728 8.41577 19.2408 8.41577 15.1458C8.41577 11.0499 11.7649 7.71869 15.8813 7.71869C19.9976 7.71869 23.3467 11.0499 23.3467 15.1458C23.3467 19.2408 19.9976 22.5728 15.8813 22.5728Z",
    fill: "#FFDD00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8135 5.55261C24.7582 5.55261 25.5239 6.31466 25.5239 7.25452C25.5239 8.19452 24.7582 8.95642 23.8135 8.95642C22.8684 8.95642 22.1025 8.19452 22.1025 7.25452C22.1025 6.31466 22.8684 5.55261 23.8135 5.55261Z",
    fill: "#FFDD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramYellow);
export default __webpack_public_path__ + "static/media/instagram-yellow.7a7952c195717f7b001e402f7fe3dea3.svg";
export { ForwardRef as ReactComponent };